import React from 'react';
import { Trans } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { formatCurrency } from '../../utils/formatters';
import { useIsAcomba } from '../../hooks/useIsAcomba';
import { ReliabilityNoticeLine } from './ReliabilityNoticeLine';
import { ReliabilityNoticeLink } from './ReliabilityNoticeLink';

interface TransphereUnappliedIndicatorProps {
    totalAmount: number;
    /** Opens Acomba GO's collection window. Omitted when there is no portal host to deep-link into. */
    onApply?: () => void;
}

// Shown above the relance list when Transphere has collected payments not yet applied in the tenant's
// Acomba GO books — so some customers below may have already paid.
export const TransphereUnappliedIndicator: React.FC<TransphereUnappliedIndicatorProps> = ({ totalAmount, onApply }) => {
    // Only an Acomba desktop reader can follow the menu path; a browser or out-of-portal session cannot.
    const isAcomba = useIsAcomba();

    return (
        <ReliabilityNoticeLine testId="transphere-indicator">
            <Trans
                i18nKey={isAcomba
                    ? TranslationKey.Home.TransphereIndicator.MessageDesktop
                    : TranslationKey.Home.TransphereIndicator.Message}
                values={{ total: formatCurrency(totalAmount) }}
                components={{
                    action: <ReliabilityNoticeLink onClick={onApply} testId="transphere-indicator-apply-btn" />,
                    amount: <span className="font-semibold" />,
                }}
            />
        </ReliabilityNoticeLine>
    );
};
